<dialog-draggable-header>
   Tool Front Loader: {{this.data.programName}} - {{this.data.modelYear}} - {{this.data.style}}
</dialog-draggable-header>

<gm-loading-spinner *ngIf="loading"></gm-loading-spinner>

<div mat-dialog-content>
   <form class="flex-dialog-container" [formGroup]="toolFrontLoaderForm">

      <mat-form-field>
         <mat-label for="program-type">Program Type</mat-label>
         <mat-select formControlName="programType">
            <mat-option *ngFor="let type of programTypeOptions" [value]="type.value">{{type.name}}</mat-option>
         </mat-select>
      </mat-form-field>

      <mat-form-field>
         <mat-label for="biw-engineer">BIW Engineer</mat-label>
         <input id="biw-engineer" matInput formControlName="engineerBIW" [matAutocomplete]="biwEngineerAuto"
            autocomplete="off" />
         <mat-autocomplete #biwEngineerAuto [displayWith]="displayEngineer">
            <mat-option *ngFor="let biw of filteredBIWEngineers$ | async" [value]="biw"> {{biw.lastFirstName}}
            </mat-option>
         </mat-autocomplete>
         <mat-error *ngIf="this.toolFrontLoaderForm.get('engineerBIW').hasError('noEngineerBIW')">
            Select an EngineerBIW from dropdown options
         </mat-error>
      </mat-form-field>

      <mat-form-field>
         <mat-label for="dei-engineer">DEI Engineer</mat-label>
         <input id="dei-engineer" matInput formControlName="engineerDEI" [matAutocomplete]="deiEngineerAuto"
            autocomplete="off" />
         <mat-autocomplete #deiEngineerAuto [displayWith]="displayEngineer">
            <mat-option *ngFor="let dei of filteredDEIEngineers$ | async" [value]="dei">{{dei.lastFirstName}}
            </mat-option>
         </mat-autocomplete>
         <mat-error *ngIf="this.toolFrontLoaderForm.get('engineerDEI').hasError('noEngineerDEI')">
            Select an EngineerDEI from dropdown options
         </mat-error>
      </mat-form-field>

      <mat-form-field>
         <mat-label for="gae-engineer">GAE Engineer</mat-label>
         <input id="gae-engineer" matInput formControlName="engineerGAE" [matAutocomplete]="gaeEngineerAuto"
            autocomplete="off" />
         <mat-autocomplete #gaeEngineerAuto [displayWith]="displayEngineer">
            <mat-option *ngFor="let gae of filteredGAEEngineers$ | async" [value]="gae">{{gae.lastFirstName}}
            </mat-option>
         </mat-autocomplete>
         <mat-error *ngIf="this.toolFrontLoaderForm.get('engineerGAE').hasError('noEngineerGAE')">
            Select an EngineerGAE from dropdown options
         </mat-error>
      </mat-form-field>

   </form>
   <div class="required">
      Note: All fields are required.
   </div>
</div>
<div mat-dialog-actions class="mat-dialog-actions-end no-margin">

   <button mat-raised-button color="primary" (click)="onAddClick()" (keypress.enter)="onAddClick()"
      [disabled]="toolFrontLoaderForm.invalid">Add Templates</button>
   <button mat-raised-button mat-dialog-close cdkFocusInitial (click)="onCloseClick()"
           (keypress.enter)="onCloseClick()">Cancel</button>
</div>